/**
 * NiceAdmin-style navigation overrides.
 */
export const navigationCustomizations = {
  MuiListItemButton: {
    styleOverrides: {
      root: {
        borderRadius: 8,
        '& *': { color: 'inherit' },
        '&:visited': { color: 'inherit' },
        '& a': { color: 'inherit !important' },
        '& a:visited': { color: 'inherit !important' },
      },
    },
  },
};
